import type { FilterMode } from "./type.ts";

export const activeConfiguration: {
  mode: FilterMode;
  activeFilterId?: string;
  openFilterIds: Set<string> | null;
  /**
 *
 *
 *
 *
 */
  secondLevelFilterId?: string;
  /**
 *
 */
  allLevelSheet: boolean;
} = $state({
  mode: "default",
  activeFilterId: undefined,
  openFilterIds: null,
  secondLevelFilterId: undefined,
  allLevelSheet: false,
});

/*                                                                                            */
export function setAllLevelSheet(enabled: boolean) {
  activeConfiguration.allLevelSheet = enabled;
}

/**
 *
 *
 *
 *
 *
 */
export function resolveFilterMode(filterId: string | undefined): FilterMode {
  if (activeConfiguration.allLevelSheet && activeConfiguration.secondLevelFilterId !== undefined) {
    return filterId === activeConfiguration.secondLevelFilterId ? "sheetSecondLevel" : "sheetFirstLevel";
  }
  return activeConfiguration.mode;
}

export function setActiveConfiguration(mode: FilterMode, activeFilterId?: string) {
  activeConfiguration.mode = mode;
  activeConfiguration.activeFilterId = activeFilterId;
}

/**
 *
 *
 *
 */
export function enterSecondLevelFilter(filterId: string) {
  activeConfiguration.activeFilterId = filterId;
  activeConfiguration.secondLevelFilterId = filterId;
}

/*                                                                                */
export function exitSecondLevelFilter() {
  activeConfiguration.secondLevelFilterId = undefined;
  activeConfiguration.activeFilterId = undefined;
}

export function setOpenFilterIds(filterIds: string[]) {
  activeConfiguration.openFilterIds = new Set(filterIds);
}

export function toggleFilterAccordion(filterId: string, isOpen: boolean) {
  const next = new Set(activeConfiguration.openFilterIds ?? []);
  if (isOpen) {
    next.add(filterId);
  } else {
    next.delete(filterId);
  }
  activeConfiguration.openFilterIds = next;
}
